import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import { useCurrentShipmentType } from "../../../hooks/useCurrentShipmentType";
import { selectActorEoriNo } from "../../selectors";
import { useDebounce, useUpdateEffect } from "../../../hooks";
import PopUpIcon from "../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../TranslateContext";

const SupplyChainActorDetails = ({item:{id,role,owner,identification},deleteData,updateData,saveData}) => {
 
  const additionalSupplyChainRoles= useSelector((state) => state.DropDownValues.additionalSupplyChainRoles);
  const { isImportShipment} = useCurrentShipmentType();
  const ownerList = useSelector((state) => isImportShipment ? state.DropDownValues.supplyChainOwnerImport :state.DropDownValues.supplyChainOwnerExport);
  const eroiNoByActor=useSelector((state)=>selectActorEoriNo(state,owner))
  const debouncedValue = useDebounce(eroiNoByActor, 300)
  useUpdateEffect(()=>{
     saveData({id, identification:eroiNoByActor})
     updateData(id,{identification:eroiNoByActor})
  },[debouncedValue])
  const translate = React.useContext(TranslateContext).translate;

  const isFormDisabled =false;
  return (
    <Grid.Row>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom b-rw-0"
      >
        <DropDown
           id={`supplyRole${id}`}
          label={translate("ROLE", {ns:["default", "parties"]})}
          disabled={isFormDisabled}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={additionalSupplyChainRoles}
          value={role}
          onChange={(value) => {
            saveData({id,role:value})
            updateData(id,{"role":value})}
          
          }
        />
      </Grid.Column>
      <Grid.Column
        width="5"
        className="divFormFeild  border-bottom  b-rw-0"
      >
        <InputField
          isLabel={false}
          id={`supplyIdentify${id}`}
          type="text"
          label={
            <React.Fragment>
            <PopUpIcon  icon="info circle"
            popupText={
            <ul><li>
              {translate("AUTHORIZATION_POP_1", {ns:["default", "parties"]})}
              </li></ul>
            }></PopUpIcon>
            {translate("IDENTIFICATION", {ns:["default", "parties"]})}
            </React.Fragment>
          }
        
          value={identification}
          className="field-bg"
          clearInput={false}
          onChange={(value) =>updateData(id,{"identification":value})}
          onBlur={(value) =>saveData({id,identification})}
          disabled={isFormDisabled}
        />
      </Grid.Column>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom"
      >
        <DropDown
          id={`supplyOwner${id}`}
          label={translate("OWNER", {ns:["default", "parties"]})}
          disabled={isFormDisabled}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={ownerList}
          value={owner}
          onChange={(value) => {
            saveData({id,owner:value})
            updateData(id, {"owner":value})}
          }
        
        />
      </Grid.Column>
      <Grid.Column width="1" className="icon-delete-add-info">
        
          <span>
            
              <Icon
                name="trash alternate outline"
                onClick={() =>deleteData(id)}
                disabled={isFormDisabled}
              />
            
          </span>
        
      </Grid.Column>
    </Grid.Row>
  );
}

export default React.memo(SupplyChainActorDetails)
